import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../../components/ui/Header';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import SocialLogin from './components/SocialLogin';
import LoginFooter from './components/LoginFooter';

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if user is already authenticated
    const token = localStorage.getItem('authToken');
    if (token) {
      navigate('/user-dashboard');
    }
  }, [navigate]);

  const handleLogin = async (credentials) => {
    setLoading(true);
    
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Mock successful login
      const mockUser = {
        id: 1,
        email: credentials?.email,
        name: 'Alex Rodriguez',
        avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face',
        preferences: {
          bikeType: 'road',
          experienceLevel: 'intermediate',
          budget: 'moderate'
        },
        stats: {
          bikesAnalyzed: 3,
          upgradesCompleted: 7,
          moneySaved: 450
        }
      };

      const token = 'mock-jwt-token-' + Date.now();
      
      localStorage.setItem('authToken', token);
      localStorage.setItem('userProfile', JSON.stringify(mockUser));
      
      // Remember me functionality
      if (credentials?.rememberMe) {
        localStorage.setItem('rememberMe', 'true');
      }
      
      // Redirect to intended destination or dashboard
      const from = location?.state?.from?.pathname || '/user-dashboard';
      navigate(from, { replace: true });
      
    } catch (error) {
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSocialLogin = async (provider) => {
    setLoading(true);
    
    try {
      // Simulate social login
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      const mockUser = {
        id: 2,
        email: `user@${provider}.com`,
        name: 'Social User',
        avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
        preferences: {
          bikeType: 'mountain',
          experienceLevel: 'beginner',
          budget: 'budget'
        },
        stats: {
          bikesAnalyzed: 0,
          upgradesCompleted: 0,
          moneySaved: 0
        }
      };

      const token = 'social-jwt-token-' + Date.now();
      
      localStorage.setItem('authToken', token);
      localStorage.setItem('userProfile', JSON.stringify(mockUser));
      
      navigate('/user-dashboard', { replace: true });
      
    } catch (error) {
      console.error('Social login error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-20 pb-12 px-6">
        <div className="max-w-md mx-auto">
          <div className="bg-card border border-border rounded-lg shadow-md p-8 animate-fade-in">
            <LoginHeader />
            
            <LoginForm 
              onLogin={handleLogin}
              loading={loading}
            />
            
            <div className="mt-6">
              <SocialLogin 
                onSocialLogin={handleSocialLogin}
                loading={loading}
              />
            </div>
            
            <LoginFooter loading={loading} />
          </div>
          
          {/* Demo Credentials Info */}
          <div className="mt-6 p-4 bg-muted/50 border border-border rounded-lg">
            <h3 className="text-sm font-semibold text-foreground mb-2">Demo Credentials</h3>
            <div className="text-xs text-muted-foreground space-y-1">
              <p><strong>Email:</strong> cyclist@bikeupgrade.com</p>
              <p><strong>Password:</strong> upgrade123</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LoginPage;